import { useCallback, useEffect, useState } from 'react';
import useViewportWidth from './useViewportWidth';

const TT_WIDTH = 160;

export type TooltipPositionType = 'top' | 'left' | 'right' | 'bottom';

export function useTooltipPosition(
    ref: React.RefObject<HTMLDivElement | null>,
    initialPosition: TooltipPositionType,
    updateKey?: number,
) {
    const [position, setPosition] = useState(initialPosition);
    const viewportWidth = useViewportWidth();

    const updatePosition = useCallback(() => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const viewportWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;

            if (initialPosition === 'right' && rect.right + TT_WIDTH > viewportWidth) {
                setPosition('left');
            } else if (initialPosition === 'left' && rect.left - TT_WIDTH < 0) {
                setPosition('right');
            } else {
                setPosition(initialPosition);
            }
        }
    }, [ref, initialPosition]);

    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout>;

        const updatePositionWithDelay = () => {
            timeoutId = setTimeout(updatePosition, 300);
        };

        updatePositionWithDelay();
        return () => {
            clearTimeout(timeoutId);
        };
    }, [updatePosition, updateKey, viewportWidth]);

    return position;
}
